import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  singleUploadToS3,
  multipleUploadToS3,
  DeleteDocs,
  downloadPDF,
  AdddocumenttoTask,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Tooltip } from "antd";
import Loader from "../../components/Common/Loader";
import DocumentUploaderWithProgress22 from "../../components/Common/Document_Uploader_With_Progress22";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import DocumentImg from "../../assets/icons/Document_2.svg";
import PlusImg from "../../assets/icons/plus-circle-white.svg";
import "../../assets/styles/local/Attachments.css";

const Attachments = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);

  const multipleUploadToS3Res = useSelector(
    (state) => state.user.multipleUploadToS3Res,
  );

  const filesInsertDocToS3Res = useSelector(
    (state) => state.user.filesInsertDocToS3Res,
  );

  const addDocumentToTaskRes = useSelector(
    (state) => state.user.addDocumentToTaskRes,
  );

  const downloadDocumentRes = useSelector(
    (state) => state.user.downloadDocumentRes,
  );

  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);

  const DeleteDocsdataRes = useSelector((state) => state.user.DeleteDocsdata);

  const handleIMGClick = () => {
    hidden_Input_File.current.click();
  };

  console.log("asc props", props);

  const [attachments, setAttachments] = useState([]);
  const [documentID, setDocumentID] = useState("");
  const [multiDocumentID, setMultiDocumentID] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  console.log("asc attachments", attachments);

  const getDocumentInfo = (item) => item?.link?.data || item?.data || item;

  const getTaskDocumentPayload = (documents) =>
    (documents || [])
      .map(getDocumentInfo)
      .filter((item) => item?.documentname && item?.link)
      .map((item) => ({
        documentname: item.documentname,
        link: item.link,
      }));

  useEffect(() => {
    if (multipleUploadToS3Res) {
      console.log("asc multi img", multipleUploadToS3Res);
    }
  }, [multipleUploadToS3Res]);

  useEffect(() => {
    if (filesInsertDocToS3Res) {
      console.log("asc multi img22", filesInsertDocToS3Res);
    }
  }, [filesInsertDocToS3Res]);

  // upload file with notification start
  const onFileUploaded = (data) => {
    console.log("asc22", data);
    const newDocuments = data.map((file) => ({
      documentname: file.name,
      documentextension: file.type,
      documentcontent: "string",
      link: file.link,
      documentsize: file.size,
      islocked: 0,
      //   uploadedbyfirstname: userFirstName,
      //   uploadedbylastname: userLastName,
      //   userId: userId,
    }));

    setAttachments((prevFileList) => [...prevFileList, ...newDocuments]);

    // start other things from here
    let updatedDocInfo = data.map(getDocumentInfo).filter(Boolean);
    props.childData(updatedDocInfo);

    let payload = getTaskDocumentPayload(updatedDocInfo);

    if (props.taskId) {
      dispatch(AdddocumenttoTask(props.taskId, payload));
    }
  };

  useEffect(() => {
    if (props.modalFunction === "update" && props.attachmentsFetchData) {
      setAttachments((prevFileList) => [...props.attachmentsFetchData]);
    }
  }, [props.attachmentsFetchData, props.modalFunction]);

  useEffect(() => {
    if (addTaskResponse.status === true) {
      let payload = getTaskDocumentPayload(attachments);
      dispatch(AdddocumenttoTask(addTaskResponse?.data?.taskid, payload));
    }
  }, [addTaskResponse]);

  const fileValidationBeforeUpload = (file) => {
    let isValid = true;
    // Check if the document with the same name already exists
    if (attachments.some((doc) => doc.documentname === file.name)) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "Document with the same name already exists.",
        },
        false,
      );
      isValid = false;
    }
    return isValid;
  };
  // upload file with notification end

  const [uploadProgress, setUploadProgress] = useState(0);
  console.log("asc progress", uploadProgress);

  const handleNotification = (multipleFiles) => {
    const isTooBig = multipleFiles.some((x) => x.size > 100 * 1024 * 1024); // 100MB
    if (isTooBig) {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: "The File is too big: Upload a file of max 100 MB.",
      });
    }
  };

  const showTooltipComp = (item) => {
    return (
      <div>
        <p className="mb-0">{item?.documentname}</p>
        <p className="mb-0">{`Uploaded ${item?.uploaded}`}</p>
      </div>
    );
  };

  return (
    <div style={{ marginTop: "3rem" }}>
      <div
        className="task-modal-dependencies-box-1 frcb"
        style={{ color: "#333333" }}
      >
        <p className="mb-0">Attachments</p>
        <p
          className="mb-0 d-none"
          //   onClick={handleIMGClick}
          onClick={() => {
            hidden_Input_File.current.click();
          }}
        >
          Add Documents
        </p>

        <DocumentUploaderWithProgress22
          maxSizeInMb={100}
          onUploaded={onFileUploaded}
          multiple={true}
          beforeFileUpload={fileValidationBeforeUpload}
        >
          <div className="d-flex gap-2 pointer ps-2">
            <img src={PlusImg} className="" alt="" />
            <p className="mb-0" style={{ color: "#00246a" }}>
              Add Document
              {/* {FetchTranslationList[40]?.translation} */}
            </p>
          </div>
        </DocumentUploaderWithProgress22>

        <input
          multiple
          type="file"
          accept="image/*,.doc,.pdf"
          ref={hidden_Input_File}
          style={{ display: "none" }}
          onChange={(e) => {
            const singleFile = e.target.files[0];
            const fileLoaded = URL.createObjectURL(singleFile); // make temporary local URL to show img in src.
            // setAdd_image(fileLoaded)
            // handleFileUpload(e);
            console.log("asc single file", singleFile);
            // dispatch(singleUploadToS3(singleFile));

            // for multiple files uploads👇
            const multipleFiles = e.target.files;
            // setAttachments(Array.from(multipleFiles));
            console.log("asc multiple files", singleFile);
            if (multipleFiles.length > 0) {
              // dispatch(
              //   multipleUploadToS3(Array.from(multipleFiles), setUploadProgress)
              // );
              // onFileUploaded(Array.from(multipleFiles));
              // handleNotification(Array.from(multipleFiles));
            }
          }}
        />
      </div>

      <div className="d-flex flex-wrap gap-2 pt-3 ps-4 ms-2">
        {attachments?.map((item, index) => {
          console.log("asc778", item);
          return (
            <div className="position-relative" key={item?.documentId}>
              {showLoader && documentID === item.documentId && (
                <div style={{ position: "absolute" }}>
                  <Loader size="small" />
                </div>
              )}
              {/* <Tooltip title={showTooltipComp(item)}> */}
              <div className="imgWithBorder" key={item?.documentId}>
                <img src={DocumentImg} className="opacity-50" alt="" />
                <span
                  onClick={() => {
                    setDocumentID(item.documentId);
                    setMultiDocumentID((prev) => [...prev, item.documentId]);
                  }}
                >
                  <p className="mb-0 fileName" title={item?.documentname}>
                    {item?.documentname?.length > 20
                      ? item.documentname.slice(0, 20) + "..."
                      : item.documentname}
                  </p>
                  <p
                    className="mb-0 fileDownload pointer"
                    onClick={() => {
                      setShowLoader(true);
                      dispatch(
                        downloadPDF(item.documentId, item.documentname),
                      ).then((res) => {
                        setMultiDocumentID((prev) =>
                          prev.filter((id) => id !== item.documentId),
                        );
                        setShowLoader(false);
                      });
                    }}
                  >
                    {item?.documentname?.split(".")[1]} | Download
                    <span className="ps-5">
                      <img
                        src={DeleteIcon}
                        className="opacity-50"
                        alt=""
                        onClick={(e) => {
                          e.stopPropagation(); // ✅ Prevent click from bubbling to parent
                          if (item.documentId) {
                            dispatch(DeleteDocs(item.documentId));
                            let data = [...attachments];
                            data.splice(index, 1);
                            setAttachments(data);
                          } else {
                            let data = [...attachments];
                            data.splice(index, 1);
                            setAttachments(data);
                          }
                        }}
                      />
                    </span>
                  </p>
                </span>
              </div>
              {/* </Tooltip> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Attachments;
